import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import "./chefListScreen.css"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BottomBar from '../BottomBar';
import { fetchChefList, fetchKitchensList, getKitchenStatus, getUsersChefInterest } from '../../store/chefActions';
import ChefCardComponent from './ChefCardComponent';

const ChefListScreen = () => {
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user);
  const chefList = useSelector((state) => state.chef.chefList);
  const chefBottomScreen = useSelector((state) => state.bottomBar.chef);
  const [componentLoaded, setComponentLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [videoLoadedIndex, setVideoLoadedIndex] = useState(0);
  const chefListRef = useRef(null);

  useEffect(() => {
    dispatch(fetchChefList());
    dispatch(fetchKitchensList());
    dispatch(getKitchenStatus());
    dispatch(getUsersChefInterest(user.userid));
  }, [dispatch]);

  useEffect(() => {
    if(chefBottomScreen && !componentLoaded){
      setComponentLoaded(true)
    }
    
  }, [chefBottomScreen]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  const videosOfChef = ["105/Chef-display-video-2.mp4",
    "102/Chef-display-video.mp4",
    "103/Chef-display-video-1.mp4",
    "104/Chef-display-video-3-1.mp4",
    "105/Chef-display-video-2.mp4",
    "106/Sonal-display-video.mp4",
    "105/Chef-display-video-2.mp4",
    "103/Chef-display-video-1.mp4",
    "104/Chef-display-video-3-1.mp4"]

  
  return (
    <div>
      {!!componentLoaded && <div className={`chefListScreenContainerWrapper ${visible ? 'open' : ''}`}>
        <div className="chefListScreenContainer">
          <div
            className={`chefListScreenComponent`}
            ref={chefListRef}
          >
            {chefList.map((chef, index) => {
              return <div key={index}>
                <ChefCardComponent chef={chef} chefCardComponentIndex={index} setVideoLoadedIndex={setVideoLoadedIndex} videoLoadedIndex={videoLoadedIndex} chefVideo={videosOfChef[index]} isChefMainScreen={false} isRoundedDesign={true} />
              </div>
            })}
          </div>
        </div>
      </div>}
      <BottomBar isExplore />
    </div>
  )
}

export default ChefListScreen